export const inventoryControl = {
	label: "Inventory",
};
